import { ManagementRoutes } from '../administracion/management-routes';

export const HIDDEN_ROUTES = [
  ManagementRoutes,
  // {
  //   data: {
  //     name: 'Hoses Report',
  //   },
  //   options: PreConfigButton1,
  //   icon: 'summarize',
  //   butons: [
  //     {
  //       data: {
  //         name: 'Reporte Manual',
  //         url: '/hoses/manually-report',
  //         exact: true,
  //         roles: housesAccionesRoles.sharedActions.manualReport,
  //       },
  //       options: PreConfigButton3,
  //     },
  //   ],
  // },
];
